const IDELIO_API_URL = `${process.env.NEXT_PUBLIC_IDELIO_API_URL}`;

export interface IdelioPayload {
  agenceId: number;
  prospect: {
    pays: string;
    numero: string;    // numéro SAISI par l’utilisateur
    ip?: string;
    cookie?: string;
  };
}

class IdelioService {
  async sendCall(payload: IdelioPayload) {
    try {
      const response = await fetch(IDELIO_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Erreur Idelio: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Erreur API Idelio :", error);
      throw error;
    }
  }
}

export const idelioService = new IdelioService();
